<div class="order-headline">
  <h2>Barcodes</h2>
  <p class="subtitle">Generiere und downloade neue Barcodes</p>
  <div class="filters">
    <div class="filter">
      <label for="numberOfBarcodes">Anzahl der Barcodes</label>
      <input
        (ngModelChange)="onNumberChange($event)"
        [(ngModel)]="numberOfBarcodes"
        class="filter-width"
        id="numberOfBarcodes"
        max="5000"
        min="1"
        pInputText
        placeholder="Zwischen 1 - 5000"
        step="1"
        type="number"
      />
      <div *ngIf="numberOfBarcodes !== undefined && (numberOfBarcodes < 1 || numberOfBarcodes > 5000)" class="validation">
        <small class="error">Bitte eine Zahl zwischen 1 und 5000 eingeben.</small>
      </div>
    </div>
    <div class="filter">
      <label for="primaryCode">Klasse</label>
      <p-dropdown
        (onChange)="onPrimaryChange()"
        [(ngModel)]="selectedPrimaryCode"
        [options]="primaryOptions"
        inputId="primaryCode"
        optionLabel="label"
        optionValue="value"
        placeholder="Bitte wählen"
        styleClass="filter-width"
      />
    </div>
    <div class="filter">
      <label for="secondaryCode">Unterklasse</label>
      <p-dropdown
        [(ngModel)]="selectedSecondaryCode"
        [disabled]="!selectedPrimaryCode"
        [options]="secondaryOptionsList"
        optionLabel="label"
        optionValue="value"
        inputId="secondaryCode"
        placeholder="Bitte wählen"
        styleClass="filter-width"
      >
        <ng-template pTemplate="selectedItem" let-selectedItem>
          <span>{{ selectedItem?.label }}</span>
        </ng-template>
        <ng-template pTemplate="item" let-option>
          <span>{{ option?.label }}</span>
        </ng-template>
      </p-dropdown>
    </div>

    <app-button (click)="downloadBarcodeFile()" [disabled]="isDownloadDisabled" label="Download" type="primary-button" />

  </div>
  <app-barcode-table [barcodeList]="barcodeHistoryList"/>

</div>
